import React, { useContext, useEffect, useState } from 'react';
import classNames from 'classnames/bind';
import { Card, CardBody } from 'reactstrap';
import SessionContext from 'SessionContext';

import BarChart from './bar-chart';
import CountWidget from './count-widget';
import CountMatchWidget from './count-match-widget';
import GenderChart from './gender-chart';
import PieChart from './pie-chart';
import DonutChart from './donut-chart';
import AdHocLocationsWidget from './ad-hoc-locations-widget';
import RiskModel from './risk-model';
import GeoBoundaryWidget from './geo-boundary-widget';
import DateRangeWidget from './date-range-widget';
import BirthdateRangeWidget from './birthdate-range-widget';
import IntRangeWidget from './int-range-widget';
import FloatRangeWidget from './float-range-widget';
import FiftyFifty from "./fifty-fifty";
import LikelihoodModel from "./likelihood-model";
import LocationTypeWidget from "./location-type-widget";

export const chart_view_map = {
  'bar': BarChart,
  'count': CountWidget,
  'counts': CountWidget,
  'counts-match': CountMatchWidget,
  'gender': GenderChart,
  'pie': PieChart,
  'risk-model': RiskModel,
  'donut': DonutChart,
  'locations': AdHocLocationsWidget,
  'location_type_counts': LocationTypeWidget,
  'person-type': CountMatchWidget,
  'geo-boundaries': GeoBoundaryWidget,
  'date-range': DateRangeWidget,
  'birthdate-range': BirthdateRangeWidget,
  'int-range': IntRangeWidget,
  'float-range': FloatRangeWidget,
  'fifty-fifty': FiftyFifty,
  'likelihood-model': LikelihoodModel
};

const Chart = (props) => {
  const context = useContext(SessionContext);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    context.crossfilterStore.chart_enter(props.chart_id);
    if (!loaded && props.chart_id === "location_type_counts") {
      props.callToUpdate && props.callToUpdate();
      setLoaded(true);
    }
    return () => {
      context.crossfilterStore.chart_leave(props.chart_id);
    };
    // eslint-disable-next-line
  }, [props.chart_id]);

  if (!context.chartsStore.loaded) {
    return <React.Fragment>Loading Chart...</React.Fragment>;
  }

  let { chart_id, crossfilter, viewOnly, filters, children, ...rest } = props;
  const config = context.chartsStore.charts[chart_id];
  const values = context.crossfilterStore[crossfilter ? 'counts_crossfiltered' : 'counts_filtered'];
  if (!config) {
    return <React.Fragment></React.Fragment>;
  }

  let uiType = config.uiType;
  if (uiType.includes("int-range") && uiType.split('-').length > 2) {
    rest.fixedWidth = uiType.split('-')[2];
    uiType = "int-range";
  }

  const View = chart_view_map[uiType.trim()];
  const className = classNames({
    'is-crossfiltered': crossfilter,
    'is-view-only': !!viewOnly,
    'is-filterable': !viewOnly
  });
  filters = filters || context.crossfilterStore.filters[chart_id] || [];

  if (filters && filters[0] && filters[0].is_negated) {
    config.excluded = "excluded: ";
  } else {
    config.excluded = "";
  }

  if (viewOnly && !filters.length && props?.originalFilters && config?.id && props.originalFilters[config.id]) {
    // display selection criteria from saved filters
    filters = Object.values(props.originalFilters[config.id]).flat() || [];
  }
  
  if (View) {
    return (
      <Card className={classNames({ "view-only": viewOnly })}>
        <CardBody className="chart-card">
          <View
            config={config}
            filters={filters}
            values={values}
            className={className}
            viewOnly={!!viewOnly}
            expandedView={props.expandedView}
            addWidgetsToRails={props.addWidgetsToRails}
            onClick={props.onClick}
            chart_id={chart_id}
            key={chart_id}
            {...props}
            {...rest}
          >
            {children}
          </View>
        </CardBody>
      </Card>
    );
  } else {
    return <div></div>;
  }
};
export default Chart;
